import React from 'react';
import { Alert } from '@material-ui/lab';
import { useTranslation } from 'react-i18next';
import { DuplicatedAlert } from './DuplicatedAlert';
import { parseDuplicatedError } from '../utils/parseDuplicatedError';

interface IErrorAlert {
    error: string;
}

/**
 * Handles API error messages:
 * - Duplicated lead/contact: Errors.LeadIsDuplicated:{id} or Errors.ContactIsDuplicated:{id}
 * - Other errors: translates key before first " - " and shows the rest as detail
 */
export const ErrorAlert = ({ error }: IErrorAlert) => {
    const { t } = useTranslation();

    const duplicatedMatch = parseDuplicatedError(error);

    if (duplicatedMatch) {
        return (
            <DuplicatedAlert
                key={duplicatedMatch.entityId}
                entityId={duplicatedMatch.entityId}
                entityType={duplicatedMatch.entityType}
            />
        );
    }

    const parts = error.split(' - ');
    const translationKey = parts[0]?.trim();
    const additionalInfo = parts.slice(1).join(' - ');

    let translatedMessage = translationKey;
    try {
        if (translationKey && translationKey.includes('.')) {
            const translated = t(translationKey);
            translatedMessage =
                translated !== translationKey ? translated : translationKey;
        }
    } catch (e) {
        translatedMessage = translationKey;
    }

    return (
        <Alert severity="error">
            {additionalInfo ? (
                <>
                    {translatedMessage}
                    {additionalInfo && (
                        <span
                            style={{
                                display: 'block',
                                marginTop: 4,
                                fontSize: '0.875rem',
                                opacity: 0.8,
                            }}
                        >
                            {additionalInfo}
                        </span>
                    )}
                </>
            ) : (
                translatedMessage
            )}
        </Alert>
    );
};
